// Formatação com Intl nativo (pt-BR). Evita date-fns/locale, que é ESM puro e
// não roda no jest do react-scripts.

const hora = new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" });
const diaHora = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const relativo = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });

export const horaMensagem = (iso: string) => {
  const d = new Date(iso);
  return d.toDateString() === new Date().toDateString() ? hora.format(d) : diaHora.format(d);
};

const UNIDADES: [Intl.RelativeTimeFormatUnit, number][] = [
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60],
];

export const haQuantoTempo = (iso?: string) => {
  if (!iso) return "";
  const segundos = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  for (const [unidade, tamanho] of UNIDADES) {
    if (Math.abs(segundos) >= tamanho) return relativo.format(Math.round(segundos / tamanho), unidade);
  }
  return "agora";
};

// "11999998888" → "(11) 99999-8888"
export const formatTelefone = (tel: string) => {
  const d = tel.replace(/\D/g, "");
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return tel;
};
